export default {"src":"/_next/static/media/arrow.98ee8e3c.svg","height":68,"width":68};